export enum EAasmState {
  DEFAULT = 'default',
  CUSTOM = 'custom',
  STANDARD = 'standard',
  INIT = 'init',
  DENIED = 'denied',
  AWAITING = 'awaiting',
  APPROVED = 'approved',
  READY = 'ready',
  IN_PROGRESS = 'in_progress',
  NEW_PLAN = 'new_plan',
  PAID = 'paid',
  IN_PROCESS = 'in_process',
  CAN_BE_PROCESS = 'can_be_process',
  DEFAULT_PAYMENT = 'default_payment',
  PAID_IN_NEXT_MONTH = 'paid_in_next_month',
  DOWNLOADED = 'downloaded',
  PROCESSING = 'processing',
  PARSED = 'parsed',
  ERROR = 'error',
}

export enum EExpectedAction {
  UPDATE = 'update',
  CREATE = 'create',
}

export type PickFromEnum<E, Keys extends keyof E> = E[Keys];

export type PickStatus<K extends keyof typeof EAasmState = keyof typeof EAasmState> = `${PickFromEnum<typeof EAasmState, K>}`;
